import API_CLIENT from "../../utils/Api";
import { buildPayload } from "../../utils/helper";

export const GetStoreDetails = async () => {
  return await API_CLIENT.get(`/stores`);
};
export const UpdateStoreDetails = async (payload) => {
  const sanitizedPayload = buildPayload(payload);
  return await API_CLIENT.patch("/stores", sanitizedPayload);
};
